// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"558":"86e863a8","890":"865c101c"}[chunkId] + ".chunk.css";
};